import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed } from "shared/lib/styles";
import { theme } from "shared/lib/styles/theme";

import { ContentItemHomeLatestV2 } from "scmp-app/components/content/content-item-render/variants/home-latest-v2";

import IconArrow from "./icon-arrow.svg";

export const SectionTitleLink = styled(BaseLink)`
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;

  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;

export const ItemsContainer = styled.div`
  display: grid;
  grid:
    "item-1" min-content
    "item-2" min-content
    "item-3" min-content
    "item-4" min-content
    "item-5" min-content
    / 100%;
  row-gap: 16px;

  ${theme.breakpoints.only("tablet")} {
    grid:
      "item-1 item-1 item-1 item-2 item-2 item-2" min-content
      "divider divider divider divider divider divider" min-content
      "item-3 item-3 item-4 item-4 item-5 item-5" min-content
      / 1fr 1fr 1fr 1fr 1fr 1fr;
    column-gap: 0;
  }
`;

export const Divider = styled.div`
  grid-area: divider;

  inline-size: 100%;
  block-size: 0;
  border-block-start: 1px #dfdfdf solid;

  ${theme.breakpoints.not("tablet")} {
    display: none;
  }
`;

const StyledContentItemHomeLatestV2 = styled(ContentItemHomeLatestV2)`
  ${theme.breakpoints.not("tablet")} {
    :not(:first-of-type) {
      border-block-start: 1px #dfdfdf solid;

      padding-block-start: 12px;

      ${theme.breakpoints.up("desktop")} {
        padding-block-start: 16px;
      }
    }
  }
`;

export const Item1 = styled(StyledContentItemHomeLatestV2)`
  grid-area: item-1;

  ${theme.breakpoints.only("tablet")} {
    padding-inline-end: 20px;
  }
`;

export const Item2 = styled(StyledContentItemHomeLatestV2)`
  grid-area: item-2;

  ${theme.breakpoints.only("tablet")} {
    padding-inline-start: 20px;
    border-inline-start: 1px #dfdfdf solid;
  }
`;

export const Item3 = styled(StyledContentItemHomeLatestV2)`
  grid-area: item-3;

  ${theme.breakpoints.only("tablet")} {
    padding-inline-end: 20px;
  }
`;

export const Item4 = styled(StyledContentItemHomeLatestV2)`
  grid-area: item-4;

  ${theme.breakpoints.only("tablet")} {
    border-inline-start: 1px #dfdfdf solid;

    padding-inline: 20px;
  }
`;

export const Item5 = styled(StyledContentItemHomeLatestV2)`
  grid-area: item-5;

  ${theme.breakpoints.only("tablet")} {
    border-inline-start: 1px #dfdfdf solid;

    padding-inline-start: 20px;
  }
`;

export const MoreLink = styled(BaseLink)`
  display: inline-flex;
  gap: 8px;
  align-items: center;

  padding-block-start: 16px;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};

  border-block-start: 1px solid #dfdfdf;
`;

export const Arrow = styled(IconArrow)`
  flex-shrink: 0;
`;
